<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">Kirim Pesan</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-warning" role="alert">
                <div class="alert-content">
                    <p>Pengiriman mengikuti timezone pengguna | {{ now }} <b>{{ timezone }}</b></p>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <SendBlast :device="device" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SendBlast from "@/components/forms/outgoing/SendBlast.vue";
    import moment from 'moment'

    export default {
        components: {
            SendBlast,
        },
        data() {
            return {
                device: [],
                timezone: "",
                now: "00:00:00",
                interval: null,
            };
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fnRefreshTable);
            this.$root.$off("toggle_modal", this.fnToggleModal);
            clearInterval(this.interval)
        },
        mounted() {
            const utc = this.$store.state?.auth?.user?.timezone || 0;
            this.interval = setInterval(() => {
                this.now = moment().utcOffset(utc).format("YYYY-MM-DD HH:mm:ss")
            }, 1000)

            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.fnRefreshTable = () => {
                this.fetchPacakge();
            }
            this.$root.$on("refresh_table", this.fnRefreshTable);

            this.getDevice({})
            this.getTimeZone()
        },
        methods: {
            getTimeZone() {
                const utc = this.$store.state?.auth?.user?.timezone || 0;
                const utcLabel = utc < 10 ? `0${utc}` : utc;
                this.timezone = `UTC +${utcLabel}:00`
            },
            toggleModal(param) {
                this.$modal.toggle(param);
            },
            async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices
            },
            fetchPacakge() {},
        },
    };
</script>
